import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Btn } from '../Btn'
import { Typography } from '../Typography'
import { SeatBox } from './styles'

export const SeatBtnBox: FC<
  {
    className?: string
    onClick?: () => void
  } & React.HTMLAttributes<HTMLDivElement>
> = ({ className, onClick, ...props }) => {
  const { t } = useTranslation()

  return (
    <SeatBox className={className} {...props}>
      <Btn
        onClick={() => {
          onClick?.()
        }}>
        <Typography variant="head3">{t('takeABox')}</Typography>
      </Btn>
    </SeatBox>
  )
}
